/* eslint-disable */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@src/configs/init-domain-config';
import '@src/utils/fetch';
import * as React from 'react';
import { HashRouter as Router } from 'react-router-dom'
import store from '@src/store';
import history from '@src/utils/history';
import { unregister } from './serviceWorker';
import Errorboundary from '@src/components/Errorboundary';
import { ConfigProvider } from '@cloud/atom-ui';
import { StoreContext } from 'redux-react-hook';
import lng from '@src/utils/lang';
import i18nInit from './i18n.js';
import 'moment/locale/zh-cn';
import '@cloud/weform-component/lib/styles.css'; //题目组件样式
// 草稿存储
import '@src/utils/storage';
require('./reset.css');
import { i18n } from '@cloud/weform-component/lib';
import urls from "@src/configs/web.config";
import { ISNEWROUTE } from '@src/utils/constant';
import { getIsLogin } from "@src/utils/isLogin";
import { changeOpen } from '@src/utils/open-url-utils';
import { queryString } from "@src/utils/common";
import { ROLE_TYPE } from '@src/routes/routes-redBlue/utils/constant';
import webConfig from '@src/routes/routes-redBlue/configs/web.config';

localStorage.removeItem(ISNEWROUTE);
let atomlocaleProviderLocale;
if (lng.lang === 'en') { // 此处为示例 language的取值由各个项目方法自己定义
  atomlocaleProviderLocale = require('@cloud/atom-ui/lib/locale-provider/en_US');
} else {
  atomlocaleProviderLocale = require('@cloud/atom-ui/lib/locale-provider/zh_CN');
}

if (process.env.REACT_APP_WELINK_ENV === 'redBlue') {
  require('./utils/uem')
}

// 兼容IE或者低版本浏览器无finally函数功能
const setFinally = () => {
  Promise.prototype.finally = Promise.prototype.finally || {
    finally(fn) {
      const onFinally = callback => Promise.resolve(fn()).then(callback);
      return this.then(
        result => onFinally(() => result),
        reason => onFinally(() => Promise.reject(reason))
      );
    }
  }.finally;
}

setFinally();

const getTrustlist = async () => {
  const res = await fetch(
    `${urls.trustlistApi}?_t=${new Date().getTime()}`,
    { method: "GET" }
  );
  return res?.data || false;
};

const getTrust = async () => {
  if (process.env.REACT_APP_WELINK_ENV === 'redBlue') return;
  const isLogin = await getIsLogin()
  if (isLogin) {
    const isNewRouter = await getTrustlist();
    localStorage.setItem(ISNEWROUTE, isNewRouter);
    return isNewRouter;
  }
};

// 内网开发者后台获取登用户角色
const getUserRole = async () => {
  const appId = queryString("appId");
  if (appId) {
    try {
      const res = await fetch(`${webConfig?.getCurrentRoleUrl}?appId=${appId}`, {
        method: "GET",
      });
      if ((res?.code === 200 && res?.data === ROLE_TYPE.noPermission) || res?.code !== 200) {
        window.location.href = '#/appList';
      }
    } catch (error) {
      return false
    }
  }
};

const oldRouteList = [
  "/guide",
  "/appdetail",
  "/createwecode",
  "/wecode/create-robot",
  "/wecode/robot-info",
  "/wecode/robot/list",
];

const newRouteList = [
  '/wecode-v2',
  '/appdetailV2',
];

const ReactDOM = require('react-dom');

import './utils/rem'
function render(app) {
  const Cmp = app;
  ReactDOM.render(
    <Errorboundary>
      <ConfigProvider locale={atomlocaleProviderLocale.default}>
        <StoreContext.Provider value={store}>
          <Router history={history}>
            <Cmp></Cmp>
          </Router>
        </StoreContext.Provider>
      </ConfigProvider>
    </Errorboundary>,
    document.getElementById('root')
  );
}

// 初始化路由
const initApp = async () => {
  // 国际化初始化
  let lang = i18nInit.getLang();
  i18n?.i18nInit(lang);
  i18nInit.initByLang(lang === 'zh' ? 'zh_CN' : 'en_US');
  window.hwLang = lang;
  const isNewRouter = await getTrust();
  if (isNewRouter) {
    const isIncludeOld = oldRouteList.some(item => window.location.hash.includes(item) || /\/[1-5]\/wecode/.test(window.location.hash));
    const isIncludeNew = newRouteList.some(item => window.location.hash.includes(item));
    if (isIncludeOld && !isIncludeNew) {
      window.location.hash = '#/0/wecode-v2'
      window.location.reload();
      return;
    }
  } else {
    const isInclude = newRouteList.some(item => window.location.hash.includes(item));
    if (isInclude) {
      window.location.hash = '#/wecode/guide/guide'
      window.location.reload();
      return;
    }
  }
  if (process.env.REACT_APP_WELINK_ENV === 'redBlue') {
    await getUserRole();
  }
  render(require('./routes').default);
  if (module.hot) {
    module.hot.accept('./routes', () => {
      const app = require('./routes').default;
      render(app);
    });
  }
}

initApp();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers:  https://developers.google.com/web/fundamentals/primers/service-workers/

unregister();
changeOpen();
